import { Module } from 'vuex'
import actions from './actions'
import RootState from '@vue-storefront/core/types/RootState'
import FacebookPixelState from '../types/FacebookPixelState';

export const module: Module<FacebookPixelState, RootState> = {
  namespaced: true,
  actions
}
